import { setTracerxUser } from 'tracerx/browser';

export interface TracerxUserContext {
  userId?: string;
  groupId?: string;
  email?: string;
  [key: string]: string | undefined;
}

export const identifyTracerxUser = (user: TracerxUserContext) => {
  const attributes = Object.fromEntries(Object.entries(user).filter(([, value]) => value));

  setTracerxUser(attributes);
};
